import React, { useRef, useEffect, useState, useCallback, useContext } from 'react'
import { Link, useLocation, useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import {
  isTablet,
  isMobile
} from 'react-device-detect'
import LeftArrowIcon from '.././icons/LeftArrowIcon.svg'
import RightArrowIcon from '.././icons/RightArrowIcon.svg'
/* --------------------------------------------- */
import { routeMap, routeVarMap } from '../../route'
/* --------------------------------------------- */
import utils from '../../utils/utils'
import { getAppLanguageWithoutRegion } from '../../utils/localStorageService'
/* --------------------------------------------- */
import RailItems from '.././RailItems'
import MediaDetailsPopUp from '.././MediaDetailsPopUp'
/* --------------------------------------------- */
import { GlobalContext } from '../../context/global.context'
/* --------------------------------------------- */
import useDetailsApi from '../../apis/useDetailsApi'
/* --------------------------------------------- */
import {
  device, railItemWidth, size,
  railItemLineHeight, centerModePadding
} from '../../constants/breakpoints'
import styled from 'styled-components'

import { Title, ViewAll, LayoutContainer } from './style'
import Spinner from '../Spinner'
/* --------------------------------------------- */
// Rail components for displaying rails.
const Rail = ({
  title, style: componentStyles = [], viewAllLink, isRailItemPlayBtn, sysId, maxItems = null, pageName, watchLaterClick,
  items, isThisCREATE, componentTheme: theme, favouritesPage, favRemoveBtnHandler, contentType, identityProvider, onScroll, tagConfiguration, isPlayerRecommendationRail
}) => {
  const [isFavEditMode, updateIsFavEditMode] = useState(false)
  const [railItemDetails, updateRailItemDetails] = useState(null)
  const [isShowRailItemPopup, updateIsShowRailItemPopup] = useState(false)
  /* --------------------------------------------- */
  const railHolderRef = useRef(null)
  const isUserDraggingRef = useRef(false)
  const railRef = useRef(null)
  const sliderRef = useRef(null)
  if (!componentStyles[0]) {
    componentStyles = [{
      type: 'grid',
      showComponentTitle: true,
      showItemTitle: true,
      itemSize: 'medium',
      itemEdgeRadius: 0.25,
      itemOrientation: 0.667,
      maxItemTitleLines: 3
    }]
  }
  let { type = '', itemSize = '', showComponentTitle = false, showViewAll = false } = componentStyles[0] || {}
  if (!type || type === 'horizontal_list') type = 'rail'
  const isTitleInsideImg = (itemSize === 'fill_width')
  /* --------------------------------------------- */
  const { setRecentSearch } = useDetailsApi()
  /* --------------------------------------------- */
  const location = useLocation()
  const history = useHistory()
  const params = useParams()
  /* --------------------------------------------- */
  const { catalogFeature } = useSelector(store => store.featuresReducers)
  const { appConfig, appMessages } = useSelector(store => store.appConfigReducers)
  const playerFeature = useSelector(store => store.featuresReducers.playerFeature)
  /* --------------------------------------------- */
  const { 
    userToken, 
    isAuthenticated, 
    selectedProfile, 
    isCastConnectedStatus, 
    userInfo, 
    isMobileUser, 
    isRailItemsLoading,
    dispatch: globalDispatch, 
    isAutoplay: globalAutoplay,
    isShowSplash,
    guestLoginStatus
  } = useContext(GlobalContext)
  /* --------------------------------------------- */
  const userTokenRef = useRef(userToken)
  const userInfoRef = useRef(userInfo)
  /* --------------------------------------------- */
  const query = utils.parse(location.search)
  const searchText = query.search || ''
  /* --------------------------------------------- */
  useEffect(() => {
    userInfoRef.current = userInfo
  }, [userInfo])
  /* --------------------------------------------- */
  /**
   * It: Sets favourite edit mode.
   */
  const favEditHandler = useCallback(() => {
    if (isFavEditMode) {
      updateIsFavEditMode(false)
    } else updateIsFavEditMode(true)
  }, [isFavEditMode])
  /* --------------------------------------------- */
  /**
   * It: Shows login popup when unauthenticated.
   */
  const authenticate = useCallback((callback = null, config = {}) => {

    const {guestPermitted} = config
    if (guestPermitted && guestLoginStatus === 'SUCCESS') {
      if (callback) callback()
        return
    }
    if (!isAuthenticated) {
      globalDispatch({ type: 'SHOW_LOGIN_POPUP' })
      if (identityProvider === "mpx") {
        globalDispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onSignupClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
              history.push(routeMap.signup)
            },
            onLoginClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
              history.push(routeMap.login)
            },
            onCloseClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      } else {
        globalDispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onCloseClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      }
    } else {
      globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
      globalDispatch({
        type: 'LOGIN_POPUP_DETAILS', value: {}
      })
      if (callback) callback()
    }
  }, [globalDispatch, isAuthenticated, history, identityProvider, guestLoginStatus])
  /* --------------------------------------------- */
  useEffect(() => {
    userTokenRef.current = userToken
  }, [userToken])
  /* --------------------------------------------- */
  /**
   * It: Handles rail item click.
   */
  useEffect(() => {
    let isMounted = true
    const railEl = railRef.current
    /* --------------------------------------------- */
    const handleClick = (e) => {
      if (isUserDraggingRef.current) return
      if (e.target.matches('.layout-item *')) {
        const path = e.path || (e.composedPath && e.composedPath())
        let railItemEl = null
        let isFavDeleteClick = false
        let isRailInfoClick = false
        for (let i = 0; i < path.length; i++) {
          if (path[i].matches('.fav-del-btn___wrapper')) {
            isFavDeleteClick = true
          } else if (path[i].matches('.rail-item-info_icon')) {
            isRailInfoClick = true
          } else if (path[i].matches('.layout-item')) {
            railItemEl = path[i]
            break
          }
        }

        if (railItemEl) {
          const index = railItemEl.getAttribute('data-index')
          if (index) {
            const {
              uid = '',
              type = '',
              date = '',
              seriesTitle = '',
              genre = [],
              actor = [],
              stage = '',
              params: railItemParams = '',
              contentOfferId = '',
              images = [],
              streams = '',
              subtitle = '',
              trailers = '',
              director = [],
              countries = [],
              seriesUid = '',
              releaseYear = '',
              description = '',
              association = '',
              seasonNumber = '',
              availableDays = '',
              episodeNumber = '',
              parentalControl = '',
              displayDuration = '',
              isCcAvailable = false,
              isHdAvailable = false,
              broadcastStartTime = '',
              isStartPlayback = false,
              isShowRailItemInfo = false,
              duration = 0,
              // isCuratedData = false
            } = items[index] || {}
            /* --------------------------------------------- */
            let { progress = 0 } = items[index] || {}
            /* --------------------------------------------- */
            const maxResumePercent = playerFeature.maxResumePercent || 95
            const currentPerc = (progress * 100) / duration
            if (currentPerc >= maxResumePercent) progress = 0
            /* --------------------------------------------- */
            let {
              title = '',
              purchaseMode = ''
            } = items[index]
            /* --------------------------------------------- */
            let linkUri = ''
            let episodeTitle = ''
            let customData = {}
            /* --------------------------------------------- */
            const typeMap = {
              match: appMessages.media_type_match,
              movie: appMessages.media_type_movie,
              series: appMessages.media_type_series,
              sportingevent: appMessages.media_type_sportingevent,
              sportingEvent: appMessages.media_type_sportingEvent,
              preview: appMessages.media_type_preview
            }
            /* --------------------------------------------- */
            const typeMapId = {
              match: appMessages.media_type_match_id,
              movie: appMessages.media_type_movie_id,
              series: appMessages.media_type_series_id,
              sportingevent: appMessages.media_type_sportingevent_id,
              sportingEvent: appMessages.media_type_sportingEvent_id,
              preview: appMessages.media_type_preview_id
            }
            /* --------------------------------------------- */
            let _pageName = pageName
            if (!_pageName) _pageName = typeMap[type] || ''
            /* --------------------------------------------- */
            /**
             * It: Constructs link url.
             */
            // console.log('## type', type, isStartPlayback)
            if (type) {
              const noWhiteSpaceTitle = (title || '').replace(/\s/g, '-').replace(/[$&+,/:;=?@"<>'#%{}|\\^~[\]]/g, '')
              if (type === 'tournament') {
                linkUri = `${routeMap.listing}?sysId=${sysId}&type=match&filterBy=tournament&filter=${uid}&title=${title}`
                if (searchText) linkUri += '&fromPage=search'
              } else if (type === 'channel') {
                linkUri = routeMap.details.replace(':pageName', _pageName).replace(':type', routeVarMap.type.channel).replace(':mediaId', `${uid}_${noWhiteSpaceTitle}`)
                // } else if (type === 'channel' && isCuratedData) {
                //   linkUri = routeMap.details.replace(':type', type).replace(':mediaId', `${uid}-${noWhiteSpaceTitle}`)
                // } else if (type === 'channel' && !isCuratedData) {
                //   linkUri = `${routeMap.player}?play=true&channelId=${uid}&progress=${progress}&duration=${duration}`
              } else if (type === 'series') {
                linkUri = routeMap.details.replace(':pageName', _pageName).replace(':type', appMessages.media_type_series_id).replace(':mediaId', `${uid}_${noWhiteSpaceTitle}`)
                if (seasonNumber) customData = { seasonNumber }
              } else if ((['match', 'movie', 'sportingevent', 'sportingEvent', 'preview'].indexOf(type) > -1) || type === 'live') {
                // console.log('## inside live')
                linkUri = routeMap.details.replace(':pageName', 'home').replace(':type', typeMapId[type] || 'm').replace(':mediaId', `${uid}_${noWhiteSpaceTitle}`)
              } else if (type === 'episode') {
                linkUri = `${routeMap.player}?mediaId=${uid}&progress=${progress}&duration=${duration}`
              } else if (type === 'product') {
                linkUri = routeMap.payment.replace(':storeProductId', uid)
              } else if (type === 'externalUri') {
                linkUri = uid
              } else if (type === 'listing') {
                linkUri = `${routeMap.listing}?sysId=${sysId}&${railItemParams}&title=${title}&pageName=${_pageName}`
              }
              if (type !== 'tournament') {
                title = `${stage ? `${stage} : ` : ''}${title}`
              }
              if (type === 'episode') {
                episodeTitle = items[index].title
                if (params.type === routeVarMap.type.series) {
                  title = `Episode ${episodeNumber} - ${title}`
                } else title = `${appMessages.label_details_season_prefix} ${seasonNumber} ${appMessages.label_details_episode_prefix} ${episodeNumber} ${title}`
              }
            }
            if (isStartPlayback) {
              linkUri = `${routeMap.player}?mediaId=${uid}&progress=${progress}&duration=${duration}`
            }
            /* --------------------------------------------- */
            if (isFavDeleteClick) {
              favRemoveBtnHandler(uid, index, title, type, contentOfferId)
            } else if (isRailInfoClick) {
              if (isStartPlayback) {
                let details = { ...(items[index] || {}) }
                delete details.isShowRailItemInfo
                delete details.isStartPlayback
                let DetailsPagelinkUri = ''
                if (type) {
                  const noWhiteSpaceTitle = (title || '').replace(/\s/g, '-').replace(/[$&+,/:;=?@"<>'#%{}|\\^~[\]]/g, '')
                  switch (type) {
                    case 'movie': DetailsPagelinkUri = routeMap.details.replace(':pageName', _pageName).replace(':type', appMessages.media_type_movie_id).replace(':mediaId', `${uid}_${noWhiteSpaceTitle}`); break
                    case 'series': DetailsPagelinkUri = routeMap.details.replace(':pageName', _pageName).replace(':type', appMessages.media_type_series_id).replace(':mediaId', `${uid}_${noWhiteSpaceTitle}`); break
                    case 'episode': if (seriesUid !== 'undefined') {
                      DetailsPagelinkUri = routeMap.details.replace(':pageName', _pageName).replace(':type', appMessages.media_type_series_id).replace(':mediaId', `${seriesUid}_${noWhiteSpaceTitle}`)
                      if (seasonNumber) details = { seasonNumber }
                    } else DetailsPagelinkUri = '/'
                      break
                    default: break
                  }
                }
                history.push(DetailsPagelinkUri, { details })
              } else {
                isMounted && updateIsShowRailItemPopup(true)
                let allowedMetaData = []
                /* --------------------------------------------- */
                if (type === 'episode') allowedMetaData = catalogFeature.seriesMetadata || []
                else allowedMetaData = catalogFeature.movieMetadata || []
                /* --------------------------------------------- */
                const genreArray = genre.map(item => {
                  return { title: item }
                })
                /* --------------------------------------------- */
                let displayDurationFormatted = null
                if (displayDuration) {
                  displayDurationFormatted = utils.millisToMinutesAndSeconds(displayDuration, {
                    hr: appMessages.label_details_h,
                    min: appMessages.label_details_min,
                    sec: appMessages.label_details_sec
                  })
                }
                /* --------------------------------------------- */
                const directorArray = director.map(item => {
                  return { title: item.personName }
                })
                /* --------------------------------------------- */
                const actorArray = actor.map((item, i) => {
                  return { title: item.personName }
                })
                /* --------------------------------------------- */
                const countriesArray = countries.map(item => {
                  return { title: item }
                })
                /* --------------------------------------------- */
                let _title = title
                let _episodeTitle = episodeTitle
                if (allowedMetaData.indexOf('title') === -1) {
                  _title = ''
                  _episodeTitle = ''
                }
                /* --------------------------------------------- */
                let _description = description
                if (allowedMetaData.indexOf('description') === -1) _description = ''
                /* --------------------------------------------- */
                let _isCcAvailable = isCcAvailable
                if (allowedMetaData.indexOf('closedCaptionAvailability') === -1) _isCcAvailable = false
                /* --------------------------------------------- */
                let _isHdAvailable = isHdAvailable
                if (allowedMetaData.indexOf('qualityIndicator') === -1) _isHdAvailable = false
                /* --------------------------------------------- */
                let _releaseYear = releaseYear
                if (allowedMetaData.indexOf('year') === -1) _releaseYear = false
                /* --------------------------------------------- */
                let _parentalControl = parentalControl
                if (allowedMetaData.indexOf('parentalRating') === -1) _parentalControl = ''
                /* --------------------------------------------- */
                let _subTitle = subtitle
                let _seriesTitle = seriesTitle
                if (allowedMetaData.indexOf('subTitle') === -1) {
                  _subTitle = ''
                  _seriesTitle = ''
                }
                /* --------------------------------------------- */
                let _displayDuration = displayDurationFormatted
                if (allowedMetaData.indexOf('duration') === -1) _displayDuration = ''
                /* --------------------------------------------- */
                const details = []
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('date') > -1) {
                  details.push({
                    key: 'date',
                    label: appMessages.label_details_date,
                    value: date && [{ title: date }]
                  })
                }
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('association') > -1) {
                  details.push({
                    key: 'association',
                    label: appMessages.label_details_association,
                    value: association && [{ title: association }]
                  })
                }
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('country') > -1) {
                  details.push({
                    key: 'countries',
                    label: appMessages.label_details_country,
                    value: countries && countriesArray.length ? countriesArray : null
                  })
                }
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('availability') > -1) {
                  details.push({
                    key: 'availableTill',
                    label: appMessages.label_details_available_for,
                    value: availableDays ? [{ title: `${availableDays} ${appMessages.details_days}` }] : null
                  })
                }
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('genre') > -1) {
                  details.push({
                    key: 'genre',
                    label: appMessages.label_details_genre,
                    value: genre && genreArray.length ? genreArray : null
                  })
                }
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('actor') > -1) {
                  details.push({
                    key: 'cast',
                    label: appMessages.label_details_cast,
                    value: actor && actorArray.length ? actorArray : null
                  })
                }
                /* --------------------------------------------- */
                if (allowedMetaData.indexOf('director') > -1) {
                  details.push({
                    key: 'director',
                    label: appMessages.label_details_director,
                    value: director && directorArray.length ? directorArray : null
                  })
                }
                /* --------------------------------------------- */
                isMounted && updateRailItemDetails({
                  url: streams,
                  trailers,
                  title: _title,
                  episodeTitle: _episodeTitle,
                  subtitle: _subTitle,
                  description: _description,
                  seriesUid,
                  type,
                  timeLeft: broadcastStartTime,
                  images,
                  displayDuration: _displayDuration,
                  episodeNumber,
                  seasonNumber,
                  releaseYear: _releaseYear,
                  isCcAvailable: _isCcAvailable,
                  seriesTitle: _seriesTitle,
                  isHdAvailable: _isHdAvailable,
                  parentalControl: _parentalControl,
                  details
                })
              }
            } else if (isShowRailItemInfo && isMobileUser) {
              const getAppDetails = {
                title,
                images,
                releaseYear,
                parentalControl,
                isCcAvailable,
                isHdAvailable,
                type
              }
              globalDispatch({
                type: 'GETAPP_POPUP_DETAILS',
                value: {
                  isShowPopup: true,
                  details: getAppDetails
                }
              })
            } else if (isShowRailItemInfo && isCastConnectedStatus && isAuthenticated) {
              const userToken = userTokenRef.current
              const userInfo = userInfoRef.current
              const userId = userInfo.userId
              const lang = getAppLanguageWithoutRegion()
              globalDispatch({
                type: 'CAST_DATA',
                data: {
                  userId,
                  userType: userInfo.customerType || '',
                  userEmailHash: userInfo.emailHash,
                  userSource: userInfo.source,
                  baseUrl: appConfig.baseUrl,
                  mediaId: uid,
                  autoplay: globalAutoplay,
                  castConfigPlaybackFormat: playerFeature.castConfig && playerFeature.castConfig.playbackAssetFormat,
                  token: userToken || '',
                  lang,
                  progress: progress / 1000
                }
              })
            } else {
              if (searchText && appConfig.baseUrl && isAuthenticated) {
                let profileId = selectedProfile ? selectedProfile.profileId : ''
                setRecentSearch(appConfig.baseUrl, title, profileId).catch(() => { })
              }
              if (linkUri) {
                if (type === 'externalUri') {
                  window.open(linkUri, '_blank')
                } else if (['product', 'episode'].indexOf(type) > -1) {
                  if (linkUri.includes(routeMap.player) && (isMobile || isTablet)) {
                    const getAppDetails = {
                      title,
                      images,
                      releaseYear,
                      parentalControl,
                      isCcAvailable,
                      isHdAvailable,
                      type
                    }
                    globalDispatch({
                      type: 'GETAPP_POPUP_DETAILS',
                      value: {
                        isShowPopup: true,
                        details: getAppDetails
                      }
                    })
                  } else {

                  authenticate(() => {
                    history.push(linkUri, {
                      details: items[index],
                      ...customData
                    })
                  }, { guestPermitted: purchaseMode === 'free' })
                 }
                } else {
                  let fwdFunction = history.push
                  if (isPlayerRecommendationRail) fwdFunction = history.replace
                  fwdFunction(linkUri, {
                    details: items[index],
                    ...customData
                  })
                }
              }
            }
          }
        }
      }
    }
    /* --------------------------------------------- */
    railEl.addEventListener('click', handleClick)
    /* --------------------------------------------- */
    return () => {
      isMounted = false
      railEl.removeEventListener('click', handleClick)
    }
  }, [
    sysId,
    items,
    history,
    searchText,
    params.type,
    isMobileUser,
    globalDispatch,
    setRecentSearch,
    appConfig.baseUrl,
    favRemoveBtnHandler,
    isCastConnectedStatus,
    selectedProfile,
    isAuthenticated,
    playerFeature,
    authenticate,
    globalAutoplay,
    playerFeature.castConfig,
    appMessages.label_details_h,
    appMessages.label_details_min,
    appMessages.label_details_sec,
    appMessages.label_details_date,
    appMessages.label_details_cast,
    appMessages.details_days,
    appMessages.label_details_genre,
    appMessages.label_details_country,
    appMessages.label_details_director,
    appMessages.label_details_association,
    appMessages.label_details_season_prefix,
    appMessages.label_details_available_for,
    appMessages.label_details_episode_prefix,
    appMessages.media_type_match,
    appMessages.media_type_movie,
    appMessages.media_type_preview,
    appMessages.media_type_series,
    appMessages.media_type_sportingEvent,
    appMessages.media_type_sportingevent,
    appMessages.media_type_match_id,
    appMessages.media_type_movie_id,
    appMessages.media_type_series_id,
    appMessages.media_type_sportingEvent_id,
    appMessages.media_type_sportingevent_id,
    appMessages.media_type_preview_id,
    railItemDetails,
    pageName,
    catalogFeature.movieMetadata,
    catalogFeature.seriesMetadata,
    isPlayerRecommendationRail
  ])
  /* --------------------------------------------- */
  useEffect(() => {
    let isMounted = true
    if (!onScroll) return
    if (type === 'rail') return

    const handleScroll = () => {
      if (!isMounted) return
      const el = railHolderRef.current
      const elBottom = el.offsetTop + el.offsetHeight
      const viewHeight = window.innerHeight
      const viewBottom = window.scrollY + viewHeight
      if (viewBottom >= elBottom - viewHeight) {
        onScroll()
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      isMounted = false
      window.removeEventListener('scroll', handleScroll)
    }
  }, [onScroll, items, type])
  /* --------------------------------------------- */
  /**
   * It: Closes popup.
   */
  const closeBtnHandle = () => {
    updateIsShowRailItemPopup(false)
  }

  let railItems = items
  if (maxItems !== null) railItems = railItems.slice(0, maxItems)
  /* --------------------------------------------- */
  /**
   * It: Play/pause slider when browser tab gains/loses focus
   */
  useEffect(() => {
    const onFocus = () => {
      componentStyles[0].autoScrollEnabled && sliderRef.current.slickPlay()
    }
    const onBlur = () => {
      sliderRef.current && sliderRef.current.slickPause()
    }

    window.addEventListener('focus', onFocus)
    window.addEventListener('blur', onBlur)

    return () => {
      window.removeEventListener('focus', onFocus)
      window.removeEventListener('blur', onBlur)
    }
  })
  /* --------------------------------------------- */
  /**
   * It: Constructs slick config based on contetntful config.
   */
  let anotherObj = {}
  componentStyles.map((singleStyle) => {
    const { filter = {}, itemSize, itemOrientation, showItemCountIndicator, autoScrollEnabled, autoscrollDelay, autoscrollDuration } = singleStyle
    /* --------------------------------------------- */
    //  In slick edge shows a choppy issues on transition, Reduce the transition duration for reduce the choppy effects.
    let platformSpecificDuration = autoscrollDuration
    if (/Edge/.test(navigator.userAgent)) platformSpecificDuration = 1200
    //  Slide transitions speed for mobile and tablet.
    if (isMobile) platformSpecificDuration = 300
    if (isTablet) platformSpecificDuration = 300
    /* --------------------------------------------- */
    const { displayOrientation: screenResolution = [] } = filter || {}
    const objTest = {}
    Object.keys(device).map((resolution) => {
      if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
      if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
      let orientation = 'landscape'
      if (itemOrientation < 1) orientation = 'portrait'
      if (itemSize === 'fill_width') orientation = 'fill_width'
      let numberOfItems = railItemWidth[orientation][itemSize][resolution]
      numberOfItems = 100 / numberOfItems
      objTest[resolution] = {
        breakpoint: size[resolution],
        settings: {
          dots: showItemCountIndicator,
          infinite: itemSize === 'fill_width',
          arrows: !isMobile && !isTablet,
          speed: autoScrollEnabled ? platformSpecificDuration : 500,
          autoplaySpeed: autoscrollDelay,
          rtl: false,
          variableWidth: false,
          pauseOnHover: true,
          autoplay: autoScrollEnabled,
          centerPadding: `${centerModePadding[orientation][resolution]}px`,
          centerMode: itemSize === 'fill_width',
          slidesToScroll: Math.floor(numberOfItems),
          slidesToShow: numberOfItems,
          touchThreshold: 15,
          beforeChange: () => isUserDraggingRef.current = true,
          afterChange: () => isUserDraggingRef.current = false
        }
      }
      return null
    })
    anotherObj = { ...anotherObj, ...objTest }
    return null
  })

  const sliderResponsive = Object.keys(anotherObj).map((key) => {
    return anotherObj[key]
  })

  const sliderSettings = {
    lazyLoad: true,
    responsive: sliderResponsive
  }
  /* --------------------------------------------- */

  return (
    <LayoutContainer {...{ componentStyles, theme }} ref={railHolderRef} className='layout'>
      {isShowRailItemPopup && <MediaDetailsPopUp {...{ isShow: isShowRailItemPopup, railItemDetails, title, type, closeBtnHandle, pageName }} />}
      {showComponentTitle && !favouritesPage &&
        <div className='layout__header'>
          {title && <Title {...{ theme }} className='layout__title'>{title}</Title>}
          {!watchLaterClick && showViewAll && viewAllLink && railItems.length > 0 && type === 'rail' &&
            <Link to={viewAllLink}>
              <ViewAll {...{ theme }} className='layout__more-link'>{appMessages.label_component_view_all}</ViewAll>
            </Link>}
          {watchLaterClick &&
            <Link onClick={watchLaterClick}>
              <ViewAll {...{ theme }} className='layout__more-link'>{appMessages?.label_may_be_later || "Maybe later"}</ViewAll>
            </Link>}
        </div>}
      {favouritesPage &&
        <div className='layout__header favouritesPage-header'>
          {isFavEditMode ? <Title {...{ theme }} className='layout__title'>{appMessages.label_favourites_edit_favourites}</Title> : <Title {...{ theme }} className='layout__title'>{appMessages.label_favourites}</Title>}
          {isFavEditMode ? <ViewAll {...{ theme }} className='fav_link layout__more-link' onClick={favEditHandler}>{appMessages.label_favourites_done}</ViewAll> : <ViewAll {...{ theme }} className='layout__more-link fav_link' onClick={favEditHandler}>{appMessages.label_favourites_edit}</ViewAll>}
        </div>}
      <LayoutBody {...{ theme, componentStyles, isTitleInsideImg, contentType, isThisCREATE }} ref={railHolderRef} className='layout__body'>
        {itemSize && componentStyles && type === 'rail' ? (
          <RailContainer  {...{ componentStyles, isThisCREATE }} ref={railRef} className={`${type} ${isFavEditMode ? 'favourites-edit-mode' : ''}`}>
            <Slider ref={sliderRef} {...sliderSettings}>
              {railItems.map((item, index) => {
                if (item.type === 'channel' && isThisCREATE && !item.isAllDataAvailable) return null
                return <RailItems key={index} {...{ ...item, isPlayerRecommendationRail, tagConfiguration, isThisCREATE, contentType, layoutType: type, isTitleInsideImg, favRemoveBtnHandler, isRailItemPlayBtn, componentStyles, index, theme, favouritesPage, sysId }} />
              })}
            </Slider>
          </RailContainer>
          )
          : (
            <RailContainer  {...{ componentStyles, isThisCREATE }} ref={railRef} className={`${type} ${isFavEditMode ? 'favourites-edit-mode' : ''}`}>
              {railItems.map((item, index) => {
                if (item.type === 'channel' && isThisCREATE && !item.isAllDataAvailable) return null
                return <RailItems key={index} {...{ ...item, tagConfiguration, isThisCREATE, contentType, layoutType: type, isTitleInsideImg, favRemoveBtnHandler, isRailItemPlayBtn, componentStyles, index, theme, favouritesPage, sysId }} />
              })}
            </RailContainer>
          )}
          {
            // Show spinner when more items are being loaded in listing page
            itemSize && componentStyles && type === 'grid' && isRailItemsLoading && !isShowSplash &&
            <div className={railItems.filter(item => !item.isPlaceholder).length === 0 ? '' : 'spinner'}>
              <Spinner size={30} />
            </div>
          }
      </LayoutBody>
    </LayoutContainer>
  )
}

const RailContainer = styled.div`
  ${({ componentStyles }) => {
    return componentStyles.map((singleStyle) => {
      const { filter = {}, itemSize } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      return Object.keys(device).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
        return `
            @media ${device[resolution]} {
              padding: ${((resolution.indexOf('mobile') !== -1 || (resolution.indexOf('tablet') !== -1)) && itemSize === 'fill_width') ? '0px!important' : '0'};
            }
          `
      })
    })
  }}
`


const LayoutBody = styled.div`
  .slick-slider {
    .slick-arrow {
      z-index: 1;
      display:none !important;
      &::before{
        display: block;
          content: '';
          width: 15px;
          height: 15px;
          background-size: 15px 15px;
          opacity: 1;
      }
      &.slick-prev{
        width: 22px;
        height: 22px;
        left: 0px;
        border-radius: 50%;
        background-color: ${({ theme: { body } }) => body?.accent?.secondary};
        border: 4px solid ${({ theme: { body } }) => body?.accent?.secondary};

        &::before{
          content: '';
          mask-image: url(${LeftArrowIcon});
          background-color: ${({ theme: { body } }) => body?.accent?.primary};
          mask-size: contain;
          mask-repeat: no-repeat;
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      &.slick-next{
       width: 22px;
       height: 22px;
       right: 0px;
       border-radius: 50%;
       background-color: ${({ theme: { body } }) => body?.accent?.secondary};
       border: 4px solid ${({ theme: { body } }) => body?.accent?.secondary};

        &::before{
          content: '';
          mask-image: url(${RightArrowIcon});
          background-color: ${({ theme: { body } }) => body?.accent?.primary};
          mask-size: contain;
          mask-repeat: no-repeat;
          width: 100%;
          height: 100%;
          display: block;
      }
        }
      }
      &.slick-disabled{
        display: none !important;
      }
    }
    &:hover{
      .slick-arrow:not(.slick-disabled){
        display: block !important;
      }
    }
  }

  ${({ componentStyles, isTitleInsideImg, pageType, isThisCREATE }) => {
    return componentStyles.map((singleStyle) => {
      const { filter = {}, showItemTopLabel, showItemTitle, maxItemTitleLines = 0, itemSize } = singleStyle
      const { displayOrientation: screenResolution = [] } = filter || {}
      return Object.keys(device).map((resolution) => {
        if (screenResolution[0] === 'landscape' && resolution.indexOf('mobile') !== -1) return ''
        if (screenResolution[0] === 'portrait' && resolution.indexOf('mobile') === -1) return ''
        const minus = railItemLineHeight[resolution] * maxItemTitleLines
        return `
        .slick-slider{
          padding-bottom:  ${itemSize === 'fill_width' ? '25px' : '0px'};
          .slick-arrow{
            display: none !important;
            @media ${device[resolution]} { 
              top: ${pageType === 'channel' && isThisCREATE ? '5000px' : (!isTitleInsideImg && (showItemTopLabel || showItemTitle) ? `calc(50% - ${minus}px)` : (isTitleInsideImg ? 'calc(50% - 25px)' : 'calc(50% - 12px)'))};
              transform: none;
            }
          }
        }
        `
      })
    })
  }}
`

/* --------------------------------------------- */
Rail.propTypes = {
  /** title of rail */
  title: PropTypes.string,
  /** theme */
  style: PropTypes.array,
  /** view all url */
  viewAllLink: PropTypes.string,
  /** show/hide rail item play button */
  isRailItemPlayBtn: PropTypes.bool,
  /** rail items data */
  items: PropTypes.array,
  /** rail theme */
  componentTheme: PropTypes.object
}
/* --------------------------------------------- */
Rail.defaultProps = {
  title: '',
  style: [],
  viewAllLink: '',
  isRailItemPlayBtn: false,
  items: [],
  componentTheme: {}
}
/* --------------------------------------------- */
export default Rail
/* --------------------------------------------- */
